export default "__VITE_ASSET__BvqF6WN3__"